module.exports = __webpack_public_path__ + "static/img/UTSC教室_3.2d3c4f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC教室_3.png
// module id = 5gU9
// module chunks = 0